/**
 * @type {BD_CFG}
 */
const CONFIG = {
    restURL: window.CFG?.restURL ?? "",
    themeURL: window.CFG?.themeURL ?? "",
    firebase: window.CFG?.firebase ?? {
        key: "",
        auth_domain: "",
        database_url: "",
        auth_token: "",
        team_code: "",
        environment: "",
    },
    game: window.CFG?.game ?? {
        id: "",
        isFinish: false,
        timeLeft: 0,
        cfgLimit: {
            timeLimit: 0,
            notifications: [],
        },
        rooms: [],
        mainrooms: [],
        is_leader: false,
        is_profile_completed: false,
        teamconnector: {
            categories: [],
            timer: 0,
        },
        game_prop: {
            disableTimer: false,
            singlePlayer: false,
        },
        sessions: {},
        settings: {
            max_players: 0,
            min_players: 0,
            layout_title :'',
            layout_subtitle :'',
            layout_paragraph :'',
            layout_team_button_text :'',
            layout_individual_button_text :'',
            layout_text_above_individual_calendar :'',
            layout_text_above_team_calendar :'',
            enroll_session_team_result_title :'',
            enroll_session_team_result_text :'',
            enroll_session_individual_confirmation_title :'',
            enroll_session_individual_confirmation_text :'',
            enroll_session_individual_result_title :'',
            enroll_session_individual_result_text :'',
            unenroll_session_individual_confirmation_title :'',
            unenroll_session_individual_confirmation_text :'',
            unenroll_session_individual_result_title :'',
            unenroll_session_individual_result_text :''
        },
        method: "",
        allocated_budget: 0,
    },
    shouldLogin: window.CFG.shouldLogin ?? 1,
    isAuth: window.CFG?.isAuth ?? 0,
    mainRoom: window.CFG?.mainRoom ?? "",
    nonce: window.CFG?.nonce ?? "",
    siteURL: window.CFG?.siteURL ?? "",
    user: window.CFG?.user ?? {
        id: 0,
        avatar: "",
        nickname: "",
        email: "",
    },
    avatarOptions: window.CFG?.avatarOptions ?? [],
    default_avatar: window.CFG.default_avatar ?? "",
    strings: {
        confirmLeave: window.CFG?.strings.confirmLeave ?? "",
        playerLeft: window.CFG?.strings.playerLeft ?? "",
        removedFromTeam: window.CFG?.strings.removedFromTeam ?? ""
    },
};

export default CONFIG;
